// extracted by mini-css-extract-plugin
export default {"wrapper":"_29b33b7b19e4f9c7","image":"_75afddebab89337f"};